import { render, staticRenderFns } from "./VideoFaqs.vue?vue&type=template&id=59c57f16&scoped=true"
import script from "./VideoFaqs.vue?vue&type=script&lang=js"
export * from "./VideoFaqs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c57f16",
  null
  
)

export default component.exports